import { ECOSYSTEM_ITEMS } from "../data/ecosystem.js";
import { SectionMeta } from "../components/SectionMeta.jsx";

export function Ecosystem() {
  return (
    <section className="section shell" id="ecosystem">
      <SectionMeta num="§ 03" label="What we are building" right="14 surfaces · one ecosystem" />

      <div className="eco-intro reveal">
        <h2 className="h-large">
          Not one thing.
          <br />
          An <em>ecosystem.</em>
        </h2>
        <p className="lead lead-flush">
          Fourteen interlocking surfaces. Pick what serves you today.
          The rest will be there when you need it.
        </p>
      </div>

      <div className="eco-grid reveal">
        {ECOSYSTEM_ITEMS.map((item, i) => (
          <article
            key={item.name}
            className={["eco-card", item.size, item.variant].filter(Boolean).join(" ")}
          >
            <div className="num">{String(i + 1).padStart(2, "0")} / 14</div>
            <div>
              <h3 className="name">{item.name}</h3>
              <p className="desc">{item.desc}</p>
            </div>
            <div className="corner" aria-hidden="true" />
          </article>
        ))}
      </div>
    </section>
  );
}
